import ajax from '@/utils/ajax.js'

export default {
    async getMemberTicketsForMobileAsync(input) {
        let response = await ajax.post("/ticket/GetMemberTicketsForMobileAsync", input);
        return response.result;
    },
    async statTouristBySexAsync(input) {
        let response = await ajax.post("/ticket/StatTouristBySexAsync", input);
        return response.result;
    },
    async statTouristByAgeRangeAsync(input) {
        input.statType = 2;
        let response = await ajax.post("/ticket/StatTouristByAgeRangeAsync", input);
        return response.result;
    },
    async statTouristByAgeRangeForDataCenterAsync(input) {
        let response = await ajax.post("/ticket/StatTouristByAgeRangeForDataCenterAsync", input);
        return response.result;
    },
    async statTouristByAreaAsync(input) {
        input.statType = 1;
        let response = await ajax.post("/ticket/StatTouristByAreaAsync", input);
        return response.result;
    },
    async statTouristByAreaForDataCenterAsync(input) {
        let response = await ajax.post("/ticket/StatTouristByAreaForDataCenterAsync", input);
        return response.result;
    },
    async getTicketCheckOverviewAsync(date) {
        let response = await ajax.post("/ticket/GetTicketCheckOverviewAsync", {
            StartDate: date,
            EndDate: date
        });
        return response.result;
    },
    async getStadiumTicketCheckOverviewAsync(input) {
        let response = await ajax.post("/ticket/GetStadiumTicketCheckOverviewAsync", input);
        return response.result;
    },
    async getScenicCheckInQuantityAsync(input) {
        let response = await ajax.post("/ticket/GetScenicCheckInQuantityAsync", input);
        return response.result;
    },
    async statTicketCheckByTradeSourceAsync(input){
        let response = await ajax.post("/ticket/StatTicketCheckByTradeSourceAsync", input);
        return response.result;
    },
    async statTicketCheckByTradeSourceForDataCenterAsync(input){
        let response = await ajax.post("/ticket/StatTicketCheckByTradeSourceForDataCenterAsync", input);
        return response.result;
    },
    async getRealTimeGroundTicketCheckOverviewAsync(){
        let response = await ajax.get("/ticket/GetRealTimeGroundTicketCheckOverviewAsync");
        return response.result;
    },
    async getRealTimeGroundTicketCheckOverview2Async(input){
        let response = await ajax.post("/ticket/GetRealTimeGroundTicketCheckOverviewAsync", input);
        return response.result;
    },
    async statTicketCheckInAsync(input)
    {
        let response = await ajax.post("/ticket/StatTicketCheckInAsync", input);
        return response.result;
    },
    async statTicketCheckByGroundForDataCenterAsync(input)
    {
        let response = await ajax.post("/ticket/StatTicketCheckByGroundForDataCenterAsync", input);
        return response.result;
    },
    async statTicketCheckInYearOverYearComparisonAsync(input)
    {
        let response = await ajax.post("/ticket/StatTicketCheckInYearOverYearComparisonAsync", input);
        return response.result;
    },
    async statTicketCheckTypeAsync(input)
    {
        let response = await ajax.post("/ticket/StatTicketCheckTypeAsync", input);
        return response.result;
    }
}